import SalesRetuenProductTable from '.';

const SalesRetuenProductTableHeader = ({
	tableError,
	setTableError,
	productTable,
	setProductTable,
	customerId,
}) => {
	const columns = [
		{ name: 'return_type_id', label: 'Return Type', type: 'return_type' },
		{ name: 'invoice_id', label: 'Invoice #', type: 'invoice_id' },
		{ name: 'product_name', label: 'Product Name', type: 'product_name' },
		{ name: 'batch_no', label: 'Batch Number', type: 'batch_no' },
		{ name: 'expiry_date', label: 'Expiry', type: 'date' },
		{ name: 'mrp', label: 'MRP', type: 'text' },
		{ name: 'quantity', label: 'QTY', type: 'text' },
		{ name: 'amount', label: 'Amount', type: 'text' },
	];

	const initialRows = [
		{
			return_type_id: null,
			invoice_id: null,
			product_id: null,
			product_name: '',
			batch_no: '',
			expiry_date: '',
			mrp: '0.00',
			quantity: '',
			amount: '0.00',
			product_batch_id: null,
			product_tax1: 0,
			product_tax2: 0,
		},
	];
	return (
		<div
			className="max-w-1297"
			style={{ paddingBottom: '160px' }}
		>
			<SalesRetuenProductTable
				initialRows={initialRows}
				columns={columns}
				customerId={customerId}
				tableError={tableError}
				setTableError={setTableError}
				productTable={productTable}
				setProductTable={setProductTable}
			/>
		</div>
	);
};
export default SalesRetuenProductTableHeader;
